import { gql } from '@apollo/client'

export default gql(`
    mutation adminLogout( $email: String! $userId: String $project: String) {
        adminLogout(
            email: $email
            project: $project
            userId: $userId
        ) {
            success{
                message
            }
            error{
                message
            }
        }
    }`
)
